import React, { useEffect, useRef } from 'react';

interface AudioAlertProps {
  enabled?: boolean;
  soundUrl?: string;
  interval?: number;
}

const AudioAlert: React.FC<AudioAlertProps> = ({
  enabled = true,
  soundUrl = '/boopboop.wav',
  interval = 5000,
}) => {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    // Create audio element if it doesn't exist
    if (!audioRef.current) {
      audioRef.current = new Audio(soundUrl);
      audioRef.current.load();
    }

    const playAudio = () => {
      if (!audioRef.current) return;
      audioRef.current.currentTime = 0;
      audioRef.current.play().catch((error) => {
        if (error.name != 'NotAllowedError') {
            //user must interact with the page first, so ignore NotAllowedError
            console.error(`Audio playback failed:${error}`)
            throw new Error('Audio playback failed')
        }
      });
    };

    if (enabled) {
      //playAudio();
      timerRef.current = setInterval(playAudio, interval);
    } else {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
    }

    // Cleanup
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
      if (audioRef.current) {
        audioRef.current.pause();
      }
    };
  }, [enabled, interval, soundUrl]);

  return null; // Non-visual component
};

export default AudioAlert;
